var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldText, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import * as React from 'react';
import { Field, Form, reduxForm, SubmissionError, } from 'redux-form';
import { ajaxSend } from 'api/api';
import { analytics } from 'app/utils/segment';
import ColorField from '../../../components/shared/util/ColorField';
import { stringToHexColor } from '../../../components/shared/util/color';
import styles from './tagsCreateModal.module.scss';
import { validate } from './utils';
export const FORM_NAME = 'addTagsForm';
var Fields;
(function (Fields) {
    Fields["name"] = "name";
    Fields["color"] = "color";
})(Fields || (Fields = {}));
class TagsCreateModalView extends React.PureComponent {
    componentDidUpdate(prevProps) {
        var _a, _b;
        const { isOpen, reset, newTagName, params: { pathname }, initialValues, } = this.props;
        if (!isOpen && prevProps.isOpen) {
            reset();
        }
        else if (isOpen && !prevProps.isOpen) {
            analytics.tagsCreateModalOpened({
                path: pathname !== null && pathname !== void 0 ? pathname : '',
                tagName: (_b = (_a = initialValues === null || initialValues === void 0 ? void 0 : initialValues.name) !== null && _a !== void 0 ? _a : newTagName) !== null && _b !== void 0 ? _b : '',
            });
        }
        if (prevProps.newTagName !== newTagName) {
            const color = newTagName && this.getHexValue(newTagName);
            this.props.changeFieldValue('name', newTagName);
            this.props.changeFieldValue('color', color);
        }
    }
    componentWillUnmount() {
        const { reset } = this.props;
        reset();
    }
    doesTagAlreadyExist(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield ajaxSend({
                path: '/v2/search',
                params: {
                    query: name,
                    strict: true,
                    scope: 'tag',
                },
            });
            const { hits } = response.data[0];
            if (hits.length) {
                const hit = hits.find((hit) => hit.name.toLowerCase() === name.toLowerCase());
                if (hit) {
                    return Promise.resolve(true);
                }
            }
            return Promise.resolve(false);
        });
    }
    handleFormSubmit(values) {
        return __awaiter(this, void 0, void 0, function* () {
            const { tags, reset, onClose, notificationAdd, selectTag, params: { path }, } = this.props;
            const { create } = tags;
            analytics.tagsCreateModalFormSubmitted({
                tagName: values[Fields.name],
                path,
            });
            const doesTagAlreadyExist = yield this.doesTagAlreadyExist(values.name);
            if (doesTagAlreadyExist) {
                const notificationOptions = {
                    title: 'Can not create tag',
                    text: `A tag with the same name already exists`,
                    icon: 'i-exclamation',
                    className: 'danger',
                };
                notificationAdd(notificationOptions);
                return;
            }
            const payload = {
                name: values.name,
                color: values.color || stringToHexColor(values.name),
            };
            create(payload)
                .then((r) => {
                const notificationOptions = {
                    title: 'Tag created',
                    text: `"${values.name}" tag has been created`,
                    icon: 'i-done',
                    className: 'success',
                    time: 5000,
                };
                notificationAdd(notificationOptions);
                selectTag && selectTag(payload);
                reset();
                onClose();
            })
                .catch((e) => {
                const notificationOptions = {
                    title: 'An error occurred',
                    text: `An error occurred when trying to create the "${values.name}" tag`,
                    icon: 'i-exclamation',
                    className: 'danger',
                };
                notificationAdd(notificationOptions);
                throw new SubmissionError({ name: 'Tag already exist' });
            });
        });
    }
    handleColorChange(color) {
        var _a;
        analytics.tagsCreateModalColorChanged({
            color,
            path: (_a = this.props.params.pathname) !== null && _a !== void 0 ? _a : '',
        });
    }
    getHexValue(tag) {
        let color = '';
        if (tag !== undefined &&
            tag !== null &&
            tag !== '' &&
            typeof tag == 'string') {
            color = stringToHexColor(tag);
        }
        return color;
    }
    nameChanged(e) {
        const tag = e.target.value.trim();
        const color = this.getHexValue(tag);
        this.props.changeFieldValue('color', color);
    }
    render() {
        const { isOpen, onClose, handleSubmit } = this.props;
        return (_jsx(Modal, Object.assign({ isOpen: isOpen, onClose: () => onClose(true), className: styles.root }, { children: _jsxs(Form, Object.assign({ onSubmit: handleSubmit(this.handleFormSubmit) }, { children: [_jsx(ModalHead, { title: "Add a new tag", onClose: () => onClose(true) }), _jsxs(ModalBody, Object.assign({ className: styles.tagModalBody }, { children: [_jsx(Field, { label: "Name", name: "name", maxLength: 255, component: FieldText, type: "text", placeholder: "Name...", required: true, onChange: this.nameChanged }), _jsx(Field, { label: "Tag color", name: "color", className: styles.colorField, component: ColorField, showSpinner: false, required: true, onChange: this.handleColorChange })] })), _jsx(ModalFoot, { cancelOnClick: () => onClose(true), cancelName: "Cancel", confirmOnClick: handleSubmit(this.handleFormSubmit), confirmName: "Save", confirmProps: {
                            disabled: this.props.invalid || this.props.pristine,
                        } })] })) })));
    }
}
__decorate([
    boundMethod
], TagsCreateModalView.prototype, "doesTagAlreadyExist", null);
__decorate([
    boundMethod
], TagsCreateModalView.prototype, "handleFormSubmit", null);
__decorate([
    boundMethod
], TagsCreateModalView.prototype, "handleColorChange", null);
__decorate([
    boundMethod
], TagsCreateModalView.prototype, "getHexValue", null);
__decorate([
    boundMethod
], TagsCreateModalView.prototype, "nameChanged", null);
export const TagsCreateModalForm = reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
    validate,
})(TagsCreateModalView);
